import React, { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import SnackbarCustom from '../../../components/SnackbarCustom';
import ApiService from '../../../services/ApiService';
import ReadOnlyInformasiKejadian from './ReadOnlyInformasiKejadian';
import LaporanInvestigasi from './LaporanInvestigasi';
import ActualImpact from './ActualImpact';
import { debounce } from 'lodash';
import { potensiTingkatKeparahanItem } from '../../../constants/tingkatKeparahan';
import KlasifikasiKecelakaan from './KlasifikasiKecelakaan';
import AnalisaPenyebab from './AnalisaPenyebab';
import TimInvestigasi from './TimInvestigasi';
import FooterReport from '../Component/FooterReport';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import {
  AppBar,
  Button,
  Dialog,
  IconButton,
  Slide,
  Toolbar,
  Typography,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';
import DialogCustom from '../../../components/DialogCustom';
import LIToPdf from './LIToPdf';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import html2pdf from 'html2pdf.js';
import InformasiTembusan from '../Component/InformasiTembusan';
import ListRekomendasi from './ListRekomendasi';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const LapInvestigasi = () => {
  // Hooks
  const navigate = useNavigate();
  const { investigasiEncode } = useParams();
  const { state } = useLocation();

  // States
  const [loading, setLoading] = useState({
    fetch: false,
    upload: false,
    submit: false,
  });
  const [snackbar, setSnackbar] = useState({
    isOpen: false,
    type: '', // "error" | "info" | "success" | "warning"
    message: '',
  });
  const [popUp, setPopUp] = useState({
    saveConfirm: false,
    success: false,
    printPdf: false,
    errorFetch: false,
    errorFetchMessage: '',
    errorSubmit: false,
    errorSubmitMessageArr: [],
  });
  const [initialData, setInitialData] = useState({});
  const [inputLaporanInvestigasi, setInputLaporanInvestigasi] = useState({
    noLapInevest: '',
    judulLaporan: '',
    tglKejadian: null,
    waktuKejadian: null,
    tglLaporan: null,
    idUnitBisnis: 0,
    idRegional: 0,
    idLokasi: 0,
    listUnitBisnis: [],
    listRegional: [],
    listLokasi: [],
    forPrint: false,
  });
  const [inputInformasiKejadian, setInputInformasiKejadian] = useState({
    deskripsiSingkat: '',
    locationTagLat: 0,
    locationTagLong: 0,
    namaLokasi: '',
    perusahaanTerlibat: '',
    isHipo: false,
    listAllKategoriInsiden: [],
    isReportAble: false,
    isRecordAble: false,
    isWorkRelated: false,
  });
  const [inputActualImpact, setInputActualImpact] = useState({
    listDetailActualImpact: [],
    actualImpactSelected: {
      // handle dropdown selection in ui
      title: [],
      type: [],
    },
    listTipePekerjaan: [],
    listDetailActualImpactContentItem: [],
    listDetailActualImpactContent: [],
    staticValueBTR: 0,
    potensiTingkatKeparahan: '',
    probabilitasKejadian: '0',
    perluDilakukanInvestigasi: false,
    pelaksanaInvestigasi: null,
    tipeInsidenId: 0,
    idMstPSELevel: null,
    mstPSELevelName: null,
    listPseLevel: [],
  });
  const [inputKlasifikasiKecelakaan, setInputKlasifikasiKecelakaan] = useState({
    detailKlasifikasiKecelakaanTrans: [],
    tipeInsidenId: 0,
    tipeInsidenName: '',
  });
  const [inputAnalisaPenyebab, setInputAnalisaPenyebab] = useState({
    listClsrCategory: [],
    clsrCategoryName: '',
    penyebabLangsung: '',
    penyebabDasar: '',
    rekomendasi: '',
    uploadDocumentList: [],
    pelaksanaInvestigasi: '',
    idTbldataMstClsrCategory: 0,
    listRekomendasi: [],
  });
  const [inputTimInvestigasi, setInputTimInvestigasi] = useState({
    listJabatan: ['Ketua Tim', 'Sekretaris', 'Anggota'],
    listNamaPegawai: [],
    timInvestigasiList: [],
    idLapInvest: 0,
  });
  const [inputInformasiTembusan, setInputInformasiTembusan] = useState({
    listKepadas: [],
    listTembusan: [],
  });
  const [dataIdamanUser, setDataIdamanUser] = useState([]);
  const [isCompleted, setIsCompleted] = useState(false);

  // Void functions
  const fetchInitialData = async () => {
    setLoading({ ...loading, fetch: true });
    try {
      const resLapInvest =
        await ApiService.getLapInvestigasi(investigasiEncode);
      if (!resLapInvest.data.isOk) throw resLapInvest.data.message;

      const { payload } = resLapInvest.data;
      // console.log("balikan lap invest", payload);
      const resMs = await Promise.all([
        ApiService.getMsUnit().then((res) => res.data.payload),
        ApiService.getMsRegional().then((res) => res.data.payload),
        ApiService.getMsLokasi(payload.idRegional).then(
          (res) => res.data.payload
        ),
        ApiService.getMsTipePekerjaan().then((res) => res.data.payload),
        ApiService.getMsClsrCategory().then((res) => res.data.payload),
        ApiService.getMsPseLevel().then((res) => res.data.payload),
      ]);

      setInitialData(payload);
      setInputLaporanInvestigasi({
        noLapInevest: payload.noLapInevest,
        judulLaporan: payload.judulLaporan,
        tglLaporan: payload.tglLaporan,
        waktuKejadian: payload.waktuKejadian,
        tglKejadian: payload.tglKejadian,
        idUnitBisnis: payload.idUnitBisnis,
        idRegional: payload.idRegional,
        idLokasi: payload.idLokasi,
        listUnitBisnis: resMs[0],
        listRegional: resMs[1],
        listLokasi: resMs[2],
        forPrint: payload.forPrint,
      });

      console.log(payload.tglKejadian);
      setInputInformasiKejadian({
        deskripsiSingkat: payload.deskripsiSingkat,
        locationTagLat: payload.locationTagLat,
        locationTagLong: payload.locationTagLong,
        namaLokasi: payload.namaLokasi,
        perusahaanTerlibat: payload.perusahaanTerlibat,
        isHipo: payload.isHipo,
        listAllKategoriInsiden: payload.listAllKategoriInsiden,
        isReportAble: payload.isReportAble,
        isRecordAble: payload.isRecordAble,
        isWorkRelated: payload.isWorkRelated,
      });
      setInputActualImpact({
        listDetailActualImpact: payload.listDetailActualImpact,
        actualImpactSelected: {
          title: new Array(payload.listDetailActualImpact.length),
          type: new Array(2),
        },
        listTipePekerjaan: resMs[3],
        listDetailActualImpactContentItem:
          payload.listDetailActualImpactContentItem,
        listDetailActualImpactContent: payload.listDetailActualImpactContent,
        staticValueBTR: payload.staticValueBTR,
        potensiTingkatKeparahan: payload.potensiTingkatKeparahan,
        probabilitasKejadian: payload.probabilitasKejadian,
        perluDilakukanInvestigasi: payload.perluDilakukanInvestigasi,
        pelaksanaInvestigasi: payload.pelaksanaInvestigasi,
        tipeInsidenId: payload.tipeInsidenId,
        idMstPSELevel: payload.idMstPSELevel,
        mstPSELevelName: payload.mstPSELevelName,
        listPseLevel: resMs[5],
      });
      const detailKlasifikasiKecelakaanTrans =
        payload?.detailKlasifikasiKecelakaanTrans;
      detailKlasifikasiKecelakaanTrans?.sort((a, b) => a.sequence - b.sequence);
      setInputKlasifikasiKecelakaan({
        tipeInsidenId: payload.tipeInsidenId,
        tipeInsidenName: payload.tipeInsidenName,
        detailKlasifikasiKecelakaanTrans,
      });
      setInputAnalisaPenyebab({
        listClsrCategory: resMs[4],
        clsrCategoryName: payload.clsrCategoryName,
        penyebabLangsung: payload.penyebabLangsung,
        penyebabDasar: payload.penyebabDasar,
        rekomendasi: payload.rekomendasi,
        uploadDocumentList: payload.uploadDocumentList,
        idTbldataMstClsrCategory: payload.idTbldataMstClsrCategory,
        listRekomendasi: payload.listRekomendasi,
      });
      setInputTimInvestigasi({
        ...inputTimInvestigasi,
        idLapInvest: payload.idLapInvest,
        pelaksanaInvestigasi: payload.pelaksanaInvestigasi,
        timInvestigasiList: payload.timInvestigasiList,
      });
      setInputInformasiTembusan({
        listKepadas: payload.listKepadas || [],
        listTembusan: payload.listTembusan || [],
      });
      setIsCompleted(payload.statusLapInvest?.toLowerCase() === 'completed');
      setLoading({ ...loading, fetch: false });
    } catch (error) {
      setLoading({ ...loading, fetch: false });
      setPopUp({ errorFetch: true, errorFetchMessage: error });
    }
  };

  const fetchLocationBasedOnRegionId = async (idRegional) => {
    try {
      const data = await ApiService.getMsLokasi(idRegional).then(
        (res) => res.data.payload
      );
      setInputLaporanInvestigasi((prev) => ({
        ...prev,
        listLokasi: data,
        idLokasi: 0,
      }));
    } catch (error) {
      setSnackbar({
        isOpen: true,
        type: 'error',
        message: error,
      });
    }
  };

  const fetchTingkatKeparahanByValue = useCallback(
    debounce(
      async (
        { detailActualImpactId, value, totalFinancialImpactValue },
        callback
      ) => {
        const percentageBTR =
          inputActualImpact.staticValueBTR == 0
            ? 0
            : Math.round(
                (totalFinancialImpactValue / inputActualImpact.staticValueBTR) *
                  100
              );

        console.log(
          'percentageBTR >>' +
            (totalFinancialImpactValue / inputActualImpact.staticValueBTR) * 100
        );
        const resSeverity = await Promise.all([
          ApiService.getTingkatKeparahanByValue({
            IdMstDetailEstimateImpact: detailActualImpactId,
            ContectValue: +value,
          }).then((res) => res.data.payload),
          ApiService.getTingkatKeparahanByValue({
            IdMstDetailEstimateImpact: 3, // Financial Impact
            ContectValue: percentageBTR,
          }).then((res) => res.data.payload),
        ]);

        callback(resSeverity);
      },
      300
    ),
    []
  );

  const fetchNamaPegawai = useCallback(
    debounce(async (value, pelaksanaInvestigasi) => {
      try {
        if (value.length < 5 || !value) {
          setInputTimInvestigasi((prev) => ({
            ...prev,
            listNamaPegawai: [],
          }));
          return;
        }
        const res = await ApiService.getMsTimInvestigasi({
          namaUser: value,
          pelaksanaInvestigasi,
        });
        console.log('res >>>', res);
        if (!res.data.isOk) throw res.data.message;

        setInputTimInvestigasi((prev) => ({
          ...prev,
          listNamaPegawai: res.data.payload,
        }));
      } catch (error) {
        setInputTimInvestigasi((prev) => ({
          ...prev,
          listNamaPegawai: [],
        }));
        setSnackbar({ isOpen: true, message: error });
      }
    }, 300),
    []
  );

  const onSubmit = async (saveAs) => {
    try {
      setLoading((prev) => ({ ...prev, submit: true }));
      // TODO VALIDATIONS

      // Omit payload
      const { listUnitBisnis, listRegional, listLokasi, ...payload1 } =
        inputLaporanInvestigasi;
      const { listAllKategoriInsiden, ...payload2 } = inputInformasiKejadian;
      const newListAllKategoriInsiden = listAllKategoriInsiden.filter(
        (o) => o.isCheked
      );
      const {
        actualImpactSelected,
        listTipePekerjaan,
        listDetailActualImpact,
        listDetailActualImpactContentItem,
        listPseLevel,
        ...payload3
      } = inputActualImpact;
      const { ...payload4 } = inputKlasifikasiKecelakaan;
      const { listClsrCategory, ...payload5 } = inputAnalisaPenyebab;
      const { listJabatan, listNamaPegawai, ...payload6 } = inputTimInvestigasi;

      const payload = {
        ...initialData,
        ...payload1,
        ...payload2,
        ...payload3,
        ...payload4,
        ...payload5,
        ...payload6,
        ...inputInformasiTembusan,
        listAllKategoriInsiden: newListAllKategoriInsiden,
        listDetailActualImpact: [],
        listDetailActualImpactContentItem: [],
        saveAs,
      };

      if (payload.isHipo === 'true') {
        payload.isHipo = true;
      } else {
        payload.isHipo = false;
      }

      let res;
      if (state?.data?.isEditMode) {
        res = await ApiService.putLapInvestigasi(payload.idLapInvest, payload);
      } else {
        if (payload.idLapInvest !== 0) {
          res = await ApiService.putLapInvestigasi(
            payload.idLapInvest,
            payload
          );
        } else {
          res = await ApiService.postLapInvestigasi(payload);
        }
      }
      setLoading((prev) => ({ ...prev, submit: false }));
      if (!res.data.isOk) throw res.data;
      setPopUp({ saveConfirm: false, success: true });
    } catch (error) {
      console.log(error);
      if (error.payload === undefined) {
        setPopUp((prev) => ({
          ...prev,
          saveConfirm: false,
          errorSubmit: true,
          errorSubmitMessageArr: [error.message],
        }));
      } else {
        setPopUp((prev) => ({
          ...prev,
          saveConfirm: false,
          errorSubmit: true,
          errorSubmitMessageArr:
            error.payload === null
              ? [error.message]
              : error.payload.length > 0
              ? error.payload
              : [error.message],
        }));
      }

      setLoading((prev) => ({ ...prev, submit: false }));
    }
  };

  const onPrintPdf = async () => {
    try {
      // const quality = 2; // Higher the better but larger file
      // const canvas = await html2canvas(document.getElementById("pdfExport"), {
      //   scale: quality,
      // });
      // const imgData = canvas.toDataURL("image/png");
      // const pdf = new jsPDF("p", "pt", "a4", true);
      // // const imgProps = pdf.getImageProperties(imgData);
      // // const pdfWidth = pdf.internal.pageSize.getWidth();
      // // const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      // const a4height = 297;
      // const a4width = 210;

      // pdf.addImage(imgData, "PNG", 0, 0, a4width, a4height);
      // pdf.save(`${inputLaporanInvestigasi.noLapInevest}.pdf`);

      const element = document.getElementById('pdfExport');

      let opt = {
        margin: [30, 0, 30, 0],
        filename: `${inputLaporanInvestigasi.noLapInevest}.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: {
          dpi: 96,
          scale: 3,
          scrollX: 0,
          scrollY: 0,
          backgroundColor: '#FFF',
        },
        jsPDF: { unit: 'pt', format: 'a4', orientation: 'p' },
      };

      html2pdf()
        .set(opt)
        .from(element)
        .toPdf()
        .get('pdf')
        .then(function (pdf) {
          let totalPages = pdf.internal.getNumberOfPages();

          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            pdf.setFontSize(8);
            pdf.setTextColor(150);
            pdf.text(
              'Page ' +
                i +
                ' of ' +
                totalPages +
                ' *) Dokumen ini dibuat melalui aplikasi HIMS (HSSE Integrated Management System) dan dinyatakan valid tanpa tanda tangan.',
              pdf.internal.pageSize.getWidth() - 570,
              pdf.internal.pageSize.getHeight() - 10
            );
          }
        })
        .save();
    } catch (error) {
      setSnackbar({
        isOpen: true,
        type: 'error',
        message: error,
      });
    }
  };

  const setIdamanUsers = useCallback(
    debounce(async (search) => {
      try {
        if (search?.trim() == '' || search?.trim().length < 5) return;
        setLoading((prev) => ({ ...prev, searchIdamanUsers: true }));

        const res = await ApiService.getIdamanUsers(search);
        if (!res.data.isOk) throw res.data;
        setDataIdamanUser(res.data.payload || []);
      } catch (error) {
        setSnackbar({
          isOpen: true,
          type: 'error',
          message: error.message,
        });
      }
      setLoading((prev) => ({ ...prev, searchIdamanUsers: false }));
    }, 200)
  );

  // Return functions

  const checkPotensi = (list) => {
    let totalDeath = 0;
    let severity;
    list.forEach((dt) => {
      if (dt.kode === 'DEAD') {
        totalDeath += Number(dt.jumlahOrNilaiKerugian);
      }
    });
    if (totalDeath > 1) {
      severity = 5;
    }
    // else if (totalDeath < 2) {
    //   severity = 4;
    // }
    else {
      severity = 4;
    }

    if (severity) {
      list = list.map((dt) => {
        if (dt.kode === 'DEAD') {
          dt.tingkatKeparahan = severity;
        }
        return dt;
      });
    }

    if (!list) list = inputActualImpact.listDetailActualImpactContent;
    const maxLevel = Math.max(...list.map((o) => parseInt(o.tingkatKeparahan)));
    if (maxLevel < 0 || maxLevel > 5) {
      return {
        potensiTingkatKeparahan: inputActualImpact.potensiTingkatKeparahan,
        // probabilitasKejadian: inputActualImpact.probabilitasKejadian,
      };
    }

    return {
      potensiTingkatKeparahan: potensiTingkatKeparahanItem.find(
        (o) => o.key == maxLevel
      ).name,
      // probabilitasKejadian: maxLevel,
    };
  };

  // UseEffects
  useEffect(() => {
    if (!investigasiEncode) return;

    fetchInitialData();
  }, []);

  useEffect(() => {
    console.log('ini', inputLaporanInvestigasi.forPrint);
    if (inputLaporanInvestigasi.forPrint) {
      setPopUp((prev) => ({ ...prev, printPdf: true }));
    }
  }, [inputLaporanInvestigasi.forPrint]);

  return (
    <>
      <h2 style={{ textAlign: 'center' }}>LAPORAN INVESTIGASI</h2>
      <LaporanInvestigasi
        input={inputLaporanInvestigasi}
        setInput={setInputLaporanInvestigasi}
        loading={loading.fetch}
        refreshLokasi={fetchLocationBasedOnRegionId}
        readOnly={isCompleted}
      />

      <ReadOnlyInformasiKejadian
        input={inputInformasiKejadian}
        setInput={setInputInformasiKejadian}
        loading={loading.fetch}
      />

      <ActualImpact
        input={inputActualImpact}
        setInput={setInputActualImpact}
        loading={loading.fetch}
        setSnackbar={setSnackbar}
        checkPotensi={checkPotensi}
        fetchTingkatKeparahan={fetchTingkatKeparahanByValue}
        readOnly={isCompleted}
      />

      {inputKlasifikasiKecelakaan.tipeInsidenId == 2 ? (
        <KlasifikasiKecelakaan
          input={inputKlasifikasiKecelakaan}
          setInput={setInputKlasifikasiKecelakaan}
          loading={loading.fetch}
          readOnly={isCompleted}
        />
      ) : null}

      <AnalisaPenyebab
        input={inputAnalisaPenyebab}
        setInput={setInputAnalisaPenyebab}
        loading={loading.fetch}
        setSnackbar={setSnackbar}
        readOnly={isCompleted}
      />
      <br />
      <InformasiTembusan
        loading={loading.fetch}
        input={inputInformasiTembusan}
        setInput={setInputInformasiTembusan}
        dataIdamanUser={dataIdamanUser}
        setIdamanUsers={setIdamanUsers}
        setDataIdamanUser={setDataIdamanUser}
        openSnack={(msg) =>
          setSnackbar({
            isOpen: true,
            type: 'error',
            message: msg,
          })
        }
        readOnly={isCompleted}
      />

      <TimInvestigasi
        input={inputTimInvestigasi}
        setInput={setInputTimInvestigasi}
        fetchNamaPegawai={fetchNamaPegawai}
        loading={loading.fetch}
        setSnackbar={setSnackbar}
        readOnly={isCompleted}
      />

      <FooterReport
        handleDraft={() => onSubmit('Draft')}
        handleSubmit={() =>
          setPopUp((prev) => ({ ...prev, saveConfirm: true }))
        }
        printOnly={isCompleted}
        handleExport={() => setPopUp((prev) => ({ ...prev, printPdf: true }))}
        newDoc={inputLaporanInvestigasi.noLapInevest !== '' ? false : true}
        newDocLapInvest={
          inputLaporanInvestigasi.noLapInevest !== '' ? false : true
        }
      />

      {/* SNACKBAR */}
      <SnackbarCustom
        duration={3000}
        type={snackbar.type || 'warning'}
        open={snackbar.isOpen}
        onClose={() => setSnackbar({ ...snackbar, isOpen: false })}
        message={snackbar.message}
      />
      {/* Dialog Konfirmasi Save */}
      <DialogCustom
        open={popUp.saveConfirm}
        handleClose={() =>
          setPopUp((prev) => ({ ...prev, saveConfirm: false }))
        }
        title={
          <>
            Notifikasi
            <IconButton
              aria-label="close"
              onClick={() =>
                setPopUp((prev) => ({ ...prev, saveConfirm: false }))
              }
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </>
        }
        content={
          <>
            Apakah anda yakin akan submit dokument ini? <br />
            Pastikan data sudah terisi dengan lengkap dan benar
          </>
        }
        actions={
          <>
            <Button
              onClick={() =>
                setPopUp((prev) => ({ ...prev, saveConfirm: false }))
              }
              variant="outlined"
              disabled={loading.submit}
            >
              Batal
            </Button>
            <LoadingButton
              onClick={() => onSubmit('Submit')}
              autoFocus
              variant="contained"
              loading={loading.submit}
              startIcon={<SaveIcon />}
              loadingPosition="start"
            >
              {!loading.submit ? 'Ya,' : ''} Submit
            </LoadingButton>
          </>
        }
      />
      <DialogCustom
        open={popUp.success}
        handleClose={() => setPopUp((prev) => ({ ...prev, success: false }))}
        title={
          <>
            Notifikasi
            <IconButton
              aria-label="close"
              onClick={() => setPopUp((prev) => ({ ...prev, success: false }))}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </>
        }
        content={<>Berhasil Menyimpan Laporan Investigasi</>}
        actions={
          <>
            <Button
              onClick={() => navigate('/hsse/incident/dashboardlkp')}
              autoFocus
              variant="contained"
            >
              Kembali ke Dashboard
            </Button>
          </>
        }
      />
      {/* PRINT PDF */}
      <Dialog
        fullScreen
        open={popUp.printPdf}
        onClose={() => setPopUp((prev) => ({ ...prev, printPdf: false }))}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={() => setPopUp((prev) => ({ ...prev, printPdf: false }))}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Export to PDF
            </Typography>
            <Button
              variant="contained"
              onClick={onPrintPdf}
              startIcon={<FileDownloadIcon />}
              sx={{
                bgcolor: 'white',
                color: '#1976d2',
                '&:hover': {
                  bgColor: '#1976d2',
                  color: 'white',
                },
              }}
            >
              Print
            </Button>
          </Toolbar>
        </AppBar>
        <LIToPdf
          id="pdfExport"
          data={{
            ...initialData,
            ...inputLaporanInvestigasi,
            ...inputInformasiKejadian,
            ...inputActualImpact,
            ...inputKlasifikasiKecelakaan,
            ...inputAnalisaPenyebab,
            ...inputTimInvestigasi,
          }}
        />
      </Dialog>
      <DialogCustom
        open={popUp.errorFetch}
        handleClose={() => setPopUp((prev) => ({ ...prev, errorFetch: false }))}
        title={
          <>
            Terjadi Kesalahan
            <IconButton
              aria-label="close"
              onClick={() =>
                setPopUp((prev) => ({ ...prev, errorFetch: false }))
              }
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </>
        }
        content={<p style={{ minWidth: 200 }}>{popUp.errorFetchMessage}</p>}
        actions={
          <>
            <Button
              onClick={() => navigate('/hsse/incident/dashboardlkp')}
              autoFocus
              variant="contained"
            >
              Kembali
            </Button>
          </>
        }
      />
      {/* Dialog Save GAGAL */}
      <DialogCustom
        open={popUp.errorSubmit}
        handleClose={() =>
          setPopUp((prev) => ({ ...prev, errorSubmit: false }))
        }
        title={
          <>
            Notifikasi
            <IconButton
              aria-label="close"
              onClick={() =>
                setPopUp((prev) => ({ ...prev, errorSubmit: false }))
              }
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </>
        }
        content={
          popUp.errorSubmitMessageArr?.length > 0 ? (
            <>
              {popUp.errorSubmitMessageArr?.map((item, idx) => (
                <p key={idx} style={{ margin: 0, padding: 0 }}>
                  {item}
                </p>
              ))}
            </>
          ) : (
            <>
              LKP Gagal Dibuat! <br />
              Silahkan periksa kembali data yang telah didinputkan.
            </>
          )
        }
        actions={
          <>
            <Button
              onClick={() =>
                setPopUp((prev) => ({ ...prev, errorSubmit: false }))
              }
              autoFocus
              variant="contained"
            >
              Tutup
            </Button>
          </>
        }
      />
    </>
  );
};

export default LapInvestigasi;
